import { zergApi } from "@/service/zerg";
import axios from "axios";


class ViaticService {

    async getWeeklyViatics(params) {
        try {
            const data = await zergApi.post("monitoring/viatic/get-weekly-viatics", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async validateApprovedAttendance(params) {
        try {
            const data = await zergApi.post("monitoring/viatic/validate-approved-attendance", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveApproveViatic(params) {
        try {
            const data = await zergApi.post("monitoring/viatic/save-approve-viatic", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const data = await zergApi.post("monitoring/viatic/viatic-export-to-excel", params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async createCaja(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/generate_caja_viatico', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ViaticService();